<div class="comentario" [ngClass]="{ 'child-comment': comment.profundidad > '1' }">
  <div class="nombre-autor-comentario">
    <ng-container *ngIf="showNombre">
      <span class="nombre-usuario">
        {{ comment?.mote ? comment?.mote.toLowerCase() : nameToShow }}
      </span>
    </ng-container>
    <ng-container *ngIf="showFecha">
      <span class="fecha-comentario"> <mat-icon class="clock-icon">schedule</mat-icon> {{ getDisplayDate(comment?.fecha_hora) }} </span>
    </ng-container>
  </div>
  <div class="texto-comentario" [innerText]="comment?.mensaje"></div>
  <div class="actions">
    <button class="action-button hoverable" [ngClass]="{ active: isLiked }" (click)="onLike()" [attr.aria-label]="isLiked ? 'Quitar me gusta' : 'Dar me gusta'">
      <app-icon-top-arrow [active]="isLiked"></app-icon-top-arrow>
    </button>
    <span
      ><strong>{{ comment.score }}</strong></span
    >
    <button class="action-button hoverable" [ngClass]="{ active: isDisliked }" (click)="onDislike()" [attr.aria-label]="isDisliked ? 'Quitar no me gusta' : 'Dar no me gusta'">
      <app-icon-down-arrow [active]="isDisliked"></app-icon-down-arrow>
    </button>
    <ng-container *ngIf="comment.profundidad <= '2'">
      <button class="reply-button" (click)="onShowTextarea()" aria-label="Responder al comentario">
        <app-icon-comments></app-icon-comments>
        <strong>Responder</strong>
      </button>
    </ng-container>
    <button class="reply-button" [disabled]="disabledReport" (click)="onReport()" aria-label="Reportar el comentario">
      <app-icon-report></app-icon-report>
      <strong>Reportar</strong>
    </button>
    <span *ngIf="disabledReport" class="reported">Reportado</span>
  </div>

  <ng-container *ngIf="showTextarea">
    <app-send-comment-textarea [idVideo]="idVideo" [idParent]="comment.id" [compact]="true" (onSendComment)="onSendComment($event)"></app-send-comment-textarea>
  </ng-container>

  <ng-container *ngIf="comment.children">
    <app-comment [comment]="comment.children[0]" [showFecha]="showFecha" [showNombre]="showNombre"></app-comment>
    <ng-container *ngIf="!showMore && comment.profundidad == '1' && comment.children.length > 1; else elseMoreButtons">
      <button class="showMore-button" (click)="onShowMore()">
        <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-circle-plus" width="24" height="24" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" />
          <path d="M9 12h6" />
          <path d="M12 9v6" />
        </svg>
        <strong>Ver más respuestas</strong>
      </button>
    </ng-container>

    <ng-template #elseMoreButtons>
      <ng-container *ngFor="let child of comment?.children | slice: 1 : comment.children.length; trackBy: trackByChildren">
        <app-comment [comment]="child" [showFecha]="showFecha" [showNombre]="showNombre"></app-comment>
      </ng-container>
    </ng-template>
  </ng-container>
</div>
